import dayjs from '@/plugins/dayjs';

export class FilterUtil {

  public percentage(perc?:string): string {
    return perc ? (parseFloat(perc) * 100).toFixed(2) + '%' : 'N/A';
  }

  public tsToString(ts:number|undefined, format:'full'|'no-seconds'|'am-pm' = 'full'): string {

    if(!ts)
      return 'N/A';
  
    switch(format) {
      case 'full': return dayjs(ts).format('DD/MM/YYYY, HH:mm:ss');
      case 'no-seconds': return dayjs(ts).format('DD/MM/YYYY, HH:mm');
      case 'am-pm': return dayjs(ts).format('L LT');
      default:
        return dayjs(ts).format(format);
    }
  }

  public maskPassword(pwd:string): string {
    return pwd.split('').map(_ch => '*').join('');
  }
}

// Export functions for Vue 3 compatibility
export function percentage(value: number): string {
  return value ? (value * 100).toFixed(2) + '%' : 'N/A';
}

export function tsToString(ts: number, format?: string): string {
  if(!ts) return 'N/A';
  
  if (!format) return dayjs(ts).format('DD/MM/YYYY, HH:mm:ss');
  
  switch(format) {
    case 'full': return dayjs(ts).format('DD/MM/YYYY, HH:mm:ss');
    case 'no-seconds': return dayjs(ts).format('DD/MM/YYYY, HH:mm');
    case 'am-pm': return dayjs(ts).format('L LT');
    case 'LLLL': return dayjs(ts).format('LLLL');
    default:
      return dayjs(ts).format(format);
  }
}

export function maskPassword(pwd: string): string {
  return pwd.split('').map(_ch => '*').join('');
}